import React from "react";
import { useNavigate } from "react-router-dom";

export const ModuleCard = ({
  moduleId,
  moduleName,
  platform,
  leg,
  location,
  lastReading,
  status,
}) => {
  const navigate = useNavigate();

  const getStatusColor = (status) => {
    switch (status) {
      case "active":
        return "bg-green-500";
      case "warning":
        return "bg-yellow-500";
      case "error":
        return "bg-red-500";
      default:
        return "bg-gray-500";
    }
  };

  return (
    <div
      className="bg-white rounded-lg shadow-md cursor-pointer hover:shadow-lg transition-shadow"
      onClick={() => navigate(`/monitoring/module/${moduleId}`)}
    >
      <div className="p-6">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-xl font-semibold">{moduleName}</h3>
          <div className={`w-3 h-3 rounded-full ${getStatusColor(status)}`} />
        </div>
        <div className="space-y-2">
          <p className="text-gray-600">Platform: {platform}</p>
          <p className="text-gray-600">Leg: {leg}</p>
          <p className="text-gray-600">Location: {location}</p>
          <div className="grid grid-cols-2 gap-2 mt-4">
            <div>
              <p className="text-sm text-gray-500">Channel 1</p>
              <p className="text-lg font-bold text-blue-600">
                {lastReading.channel1.toFixed(3)} V
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Channel 2</p>
              <p className="text-lg font-bold text-green-600">
                {lastReading.channel2.toFixed(3)} V
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Channel 3</p>
              <p className="text-lg font-bold text-purple-600">
                {lastReading.channel3.toFixed(3)} V
              </p>
            </div>
            <div>
              <p className="text-sm text-gray-500">Channel 4</p>
              <p className="text-lg font-bold text-red-600">
                {lastReading.channel4.toFixed(3)} V
              </p>
            </div>
          </div>
          <p className="text-sm text-gray-500 mt-4">
            Last updated: {new Date().toLocaleString()}
          </p>
        </div>
      </div>
    </div>
  );
};
